import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'language',
	key: 'language_id',
	fields: {
		language_id: Model.SCHEMA_NUMBER,
		language_name: Model.SCHEMA_TEXT
	}
})
